import {Component, HostListener, ViewChild, ElementRef, OnInit, Renderer2} from '@angular/core';
import {ApiService} from '../services/api.service';
import {Router} from '@angular/router';
import {InternalService} from '../services/internal.service';
import {TranslateService} from '@ngx-translate/core';
import {NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'my-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit{
  searchText: any = '';
  searchResult: any = [];
  @ViewChild('searchBox') searchBox: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;
  constructor(
    public apiService: ApiService,
    public internalService: InternalService,
    private renderer: Renderer2,
    public translate: TranslateService,
    private router: Router,
  ) {

    this.renderer.listen('window', 'click', (e: Event) => { // close search result box on click outside of box
      if (e.target !== this.searchBox.nativeElement && e.target !== this.searchInput.nativeElement) {
        document.getElementById('searchBox').style.display = 'none';
      }
    });
  }

  ngOnInit() {

  }
  search() {
    // if (!this.searchText) {
    //   document.getElementById('searchBox').style.display = 'none';
    //   return false;
    // }
    // localStorage.setItem('isLeaf', 'true');
    if (this.isEmptyOrSpaces(this.searchText)) {
      document.getElementById('searchBox').style.display = 'none';
      return false;
    }


    const body = {
      search: this.searchText
    };

    this.apiService.search(body).subscribe((res: any) => {
      this.searchResult = res.res;
      // console.log(this.searchResult);
      if (this.searchResult.length > 0) {
        this.generateSearchResultItems();
      } else {
        this.clearSearchResult();
        const result = document.getElementById('resultResult');
        const li = document.createElement('li');
        li.innerHTML = this.translate.instant('NoResultToShow');
        result.append(li);
        document.getElementById('searchBox').style.display = 'block';
      }

    });
  }

  generateSearchResultItems() {
    this.clearSearchResult();
    const result = document.getElementById('resultResult');
    for (let item of this.searchResult) {
      const li = document.createElement('li');
      // li.innerHTML = `<a href="/service-description/${item.categoryId}/${item.name.replace(/\s/g, '-')}">${item.name}</a>`;
      li.innerHTML = `<a href="/service-description/${item.categoryId}">${item.name}</a>`;
      result.append(li);
    }
    document.getElementById('searchBox').style.display = 'block';
  }

  clearSearchResult() {
    document.getElementById('resultResult').innerHTML = '';
    // document.getElementById('searchBox').style.display = 'none';
  }

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  navigateToFirstItem() {
    if (this.searchResult.length > 0) {
      // this.router.navigate(['/service-description/' + this.searchResult[0].categoryId + '/' + this.searchResult[0].name.replace(/\s/g, '-')]);
      this.router.navigate(['/service-description/' + this.searchResult[0].categoryId]);
    }
  }


}
